module.exports = __webpack_public_path__ + "4c918c9a7a4a200251235a44148cd0bd.otf";